<template>
  <div>
    <div class="page-title">Email + Password Registration Settings</div>
    <div class="checkbox-wrapper">
      <Checkbox
        label="Enable Email Validation"
        v-model="localValue.data.enable_email_validation"
        @input="checkDependentOptions"
      />
      <v-tooltip open-delay="500" max-width="300" top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" size="20" class="form-question"
            >$question_round</v-icon
          >
        </template>
        <span>
          <slot name="tooltip">When enabled, this will provide feedback to a registering user if there appears to be a typo in their email.</slot>
        </span>
      </v-tooltip>
    </div>
    <div class="suboptions" v-show="localValue.data.enable_email_validation">
      <div class="checkbox-wrapper">
        <Checkbox
          label="Show an “Are you sure?” prompt"
          v-model="localValue.data.are_you_sure_prompt"
          :disabled="!this.localValue.data.enable_email_validation"
          @input="checkDependentOptions"
        />
        <v-tooltip open-delay="500" max-width="300" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="20" class="form-question"
              >$question_round</v-icon
            >
          </template>
          <span>
            <slot name="tooltip">When enabled, if the user's email seems to have a type, this will open a modal that asks the user if they are sure their email is correct before submitting their registration. If this is disabled, the user will be allowed to register with no warning, but will be marked as “Email Validation Failed” in admin.</slot>
          </span>
        </v-tooltip>
      </div>
      <div class="checkbox-wrapper">
        <Checkbox
          label="Show suggestions"
          v-model="localValue.data.show_suggestions"
          :disabled="!this.localValue.data.are_you_sure_prompt"
        />
        <v-tooltip open-delay="500" max-width="300" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="20" class="form-question"
              >$question_round</v-icon
            >
          </template>
          <span>
            <slot name="tooltip">When enabled, this will offer suggestions to the user, if any are available. For example, if they submit “example@gmil.com”, it will suggest “example@gmail.com”.</slot>
          </span>
        </v-tooltip>
      </div>
    </div>

  </div>
</template>

<script>
import mixin from "./addon-form.mixin";

export default {
  extends: mixin,
  created() {
    this.localValue.data ||= {
      enable_email_validation: false,
      are_you_sure_prompt: false,
      show_suggestions: false
    };
    this.checkDependentOptions();
  },
  methods: {
    checkDependentOptions() {
      if(!this.localValue.data.enable_email_validation) {
        this.$set(this.localValue.data, 'are_you_sure_prompt', false);
        this.$set(this.localValue.data, 'show_suggestions', false);
      } else if(!this.localValue.data.are_you_sure_prompt) {
        this.$set(this.localValue.data, 'show_suggestions', false);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.checkbox-wrapper {
  display: flex;
  align-items: center;
  .checkbox {
    margin-right: 5px;
  }
}
.suboptions {
  margin-left: 1em;
}
</style>
